import { Grid } from "@mui/material";
import Header from "../../components/custom/Header";
import MyAccountForm from "./MyAccountForm";
import { fetchMyAccount, updateMyAccount } from "./services";
import { styled } from "@mui/system";
import { useMutation } from "react-query";
import Dialog from "../../components/custom/Dialog";
import { useEffect, useState } from "react";
import { avatarAtom, userFullNameAtom } from "../../atom/atoms";
import { useAtom } from "jotai";

const StyledContainer = styled(Grid)`
  width: 100%;
  height: 100%;
`;

const MyAccount = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState(null);
  const [, setUserFullName] = useAtom(userFullNameAtom);
  const [, setAvatar] = useAtom(avatarAtom);

  const fetchMyAccountData = async () => {
    try {
      const res = await fetchMyAccount();
      setFormData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const { mutate: updateMutate } = useMutation(updateMyAccount, {
    onSuccess: (data) => {
      setFormData(data?.data);
      setAvatar(data?.data?.avatar);
      setUserFullName(data?.data?.firstName + " " + data?.data?.lastName);
      setShowDialog(true);
      setMessage("Success update");
    },
    onError: (error) => {
      setShowDialog(true);
      setMessage(
        "Update error: " +
          (error?.response?.data?.error || error?.response?.data)
      );
    },
  });
  const updateAccount = (data) => {
    setShowDialog(true);
    setMessage("Updating profile...Please wait...");
    updateMutate(data);
  };

  useEffect(() => {
    fetchMyAccountData();
  }, []);

  return (
    <>
      <StyledContainer sx={{ p: { xs: 2, md: 10 } }}>
        <Header name="My account" productShow={false} />
        <MyAccountForm data={formData} submitAccountUpdate={updateAccount} />
        <Dialog
          showCancel={false}
          showButton={false}
          action={() => {
            setShowDialog(false);
          }}
          onClose={() => setShowDialog(false)}
          open={showDialog}
        >
          {message}
        </Dialog>
      </StyledContainer>
    </>
  );
};

export default MyAccount;
